export default function locationsTranslator(message, dispatch) {
  switch(message.update) {
    case "location created":
    case "location updated":
      dispatch({type: "companyLocation/load", location: message.location});
  }
}
